import React, { useState } from 'react';

import clsx from 'clsx';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import * as classes from './BuilderSidePanel.module.css';

const BuilderSidePanel = ({
    ...props
}) => {
    const [formulasMenuOpen, setFormulasMenuOpen] = useState(false);
    const [k2aTemplatesMenuOpen, setK2aTemplatesMenuOpen] = useState(false);
    const [companyTemplatesMenuOpen, setCompanyTemplatesMenuOpen] = useState(false);


    const ruleName = { name: 'Nathans Test Rule' };


    return (
        <div className={classes.SidePanel}>
            <div className={classes.RuleContainer}>
                <div className={classes.RuleTitle}>
                    Rule Name
                </div>
                <div className={classes.Rule}>
                    {ruleName.name}
                </div>
            </div>
            <div>
                <div>
                    <List className={classes.List}>
                        <ListItem
                            key={0}
                            onClick={() => setFormulasMenuOpen(!formulasMenuOpen)}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            <i className={clsx(`fas fa-chevron-${formulasMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                            Formulas
                        </ListItem>
                        {
                            formulasMenuOpen ?
                                <div className={classes.SubListContainer}>
                                    <List className={classes.FormulaList}>
                                        <ListItem
                                            key={0}
                                            classes={{
                                                root: classes.FormulaListItem
                                            }}
                                        >
                                            Formula A
                                        </ListItem>
                                    </List>
                                </div>
                                :
                                null
                        }
                    </List>
                </div>
                <div>
                    <List className={classes.List}>
                        <ListItem
                            key={0}
                            onClick={() => setK2aTemplatesMenuOpen(!k2aTemplatesMenuOpen)}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            <i className={clsx(`fas fa-chevron-${k2aTemplatesMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                            K2A Templates
                        </ListItem>
                        {
                            k2aTemplatesMenuOpen ?
                                <div className={classes.SubListContainer}>
                                    <List className={classes.FormulaList}>
                                        <ListItem
                                            key={0}
                                            classes={{
                                                root: classes.FormulaListItem
                                            }}
                                        >
                                            Formula A
                                        </ListItem>
                                    </List>
                                </div>
                                :
                                null
                        }
                    </List>
                </div>
                <div>
                    <List className={classes.List}>
                        <ListItem
                            key={0}
                            onClick={() => setCompanyTemplatesMenuOpen(!companyTemplatesMenuOpen)}
                            classes={{
                                root: classes.ListItem
                            }}
                        >
                            <i className={clsx(`fas fa-chevron-${companyTemplatesMenuOpen ? 'down' : 'up'}`, classes.icon)} aria-hidden="true" />
                            Company Templates
                        </ListItem>
                        {
                            companyTemplatesMenuOpen ?
                                <div className={classes.SubListContainer}>
                                    <List className={classes.FormulaList}>
                                        <ListItem
                                            key={0}
                                            classes={{
                                                root: classes.FormulaListItem
                                            }}
                                        >
                                            Formula A
                                        </ListItem>
                                    </List>
                                </div>
                                :
                                null
                        }
                    </List>
                </div>
            </div>
        </div>
    );
};

export default BuilderSidePanel;
